// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#global-cart .upsell-items .upsell-heading{font-size:1.5rem}#global-cart .upsells-items{height:27dvh}@media (min-width:1024px){#global-cart .upsells-items{height:27dvh}}", ""]);
// Exports
module.exports = exports;
